import { ComponentPropsWithoutRef } from "react";
import clsx from "clsx";

export type SectionHeaderToggleButtonProps =
  ComponentPropsWithoutRef<"button"> & {
    title: string;
    active?: boolean;
    className?: string;
    disabled?: boolean;
  };

export const SectionHeaderToggleButton = ({
  title,
  disabled = false,
  active = false,
  ...rest
}: SectionHeaderToggleButtonProps) => {
  return (
    <button
      {...rest}
      className={clsx(
        rest?.className && rest.className,
        !rest?.className && "w-full",
        disabled && "disabled:cursor",
        !disabled && "hover:text-opacity-100",
        "h-[1.8750rem] text-white text-opacity-50 cursor-pointer rounded-3xl font-semibold text-xs leading-[1.1250rem] disabled:cursor",
        active && "!text-opacity-100"
      )}
      disabled={disabled}
    >
      {title}
    </button>
  );
};
